import * as React from "react";
import "./styles.scss"
import {InputAddon, TextInput} from "@vebox/etui-core";
import {INPUT_BORDER_BOX} from "../../../components/common/etui_components_styles";

interface InfoFieldProps {
    label: string,
    value: string,
    valueClassName?: string,
    labelClassName?: string
    rootClassName?: string
    showStatus?: boolean
    statusClassName?: string
    hideLabel?: boolean
}

export const InfoField: React.FC<InfoFieldProps> = ({
                                                        label,
                                                        statusClassName,
                                                        value,
                                                        showStatus
                                                    }) => {
    return <div className={"info-field"}>
        <TextInput
            label={label}
            value={value}
            readOnly={true}
            styles={INPUT_BORDER_BOX}
            startInputAddon={showStatus ?
                <InputAddon position="start">
                    <div className={"status-circle-big " + (statusClassName ?? "")}></div>
                </InputAddon> : undefined}
        />
    </div>
}